import { filterReducerConstant } from "../reducerConstant";

const initialState = {
  filterList: [],
  categories: [],
  isSingle: false,
  singleAmount: [],
  isWeekly: false,
  weeklyAmount: [],
  isMonthly: false,
  monthlyAmount: [],
  states: [],
  page: 1,
  lastPage: 1,
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case filterReducerConstant.UPDATE_FILTER_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case filterReducerConstant.RESET_FILTER_LIST:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default filterReducer;
